export default __webpack_public_path__ + "static/media/water-4.f3732b38.png";